import React from "react";
import Error from "@cdkglobal/epay-admin-component/cjs/components/_onePay/common/error/common/Error";

const SessionTimeoutAdmin = props => {
  return (
    <Error
      errorStatus={"440"}
      errorText={"OnePay Admin Session has expired"}
      errorDescription={
        "It looks like the OnePay Admin session has expired. Please close the tab and reopen the application."
      }
    />
  );
};

export default SessionTimeoutAdmin;
